module.exports = __webpack_public_path__ + "img/changjianwenti.1e8eef05.png";